import { createFileRoute, redirect } from '@tanstack/react-router'
import { useAuthStore } from '~/client/common/stores/auth'
import { supabaseClient } from '~/server/common/supabase/client'
import { posthog } from '~/client/common/posthog'

export const Route = createFileRoute('/_app/logout')({
  beforeLoad: async () => {
    if (typeof window === 'undefined') {
      throw redirect({ to: '/login' })
    }

    // Perform logout inline to avoid rendering the layout.
    // Revoke impersonation server-side first (best-effort — mirrors logout() in auth store).
    const { impersonationToken } = useAuthStore.getState()
    if (impersonationToken !== null) {
      try {
        await useAuthStore.getState().stopImpersonation()
      } catch {
        useAuthStore.getState().clearImpersonationLocal()
      }
    }

    await supabaseClient.auth.signOut()
    posthog.reset()
    localStorage.removeItem('userDetails')
    useAuthStore.setState({
      user: null,
      userDetail: null,
      viewAsUser: null,
      viewAsUserDetail: null,
      impersonationToken: null,
      impersonationExpiresAt: null,
    })

    throw redirect({ to: '/login' })
  },
})
